'use strict';

require('babel-polyfill');

module.exports = {
    pipoHost: 'https://lk.payin-payout.net'
};


//////////////////
// WEBPACK FOOTER
// ./src/config/config.pipo.js
// module id = 383
// module chunks = 0